import { toInteger } from 'utils/string';

export const shortPollingTimespan = toInteger(process.env.REACT_APP_SHORT_POLLING_TIMESPAN) ?? 5000;

export const apiBaseUrl = process.env.REACT_APP_API_URL;
